function legacyCopyToClipboard(text: string): boolean {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "true");
  ta.style.position = "fixed";
  ta.style.left = "-9999px";
  ta.style.top = "0";
  document.body.appendChild(ta);
  ta.focus();
  ta.select();
  ta.setSelectionRange(0, text.length);
  let ok = false;
  try {
    ok = document.execCommand("copy");
  } catch {
    ok = false;
  }
  document.body.removeChild(ta);
  return ok;
}

/** 复制文本；HTTPS 用 Clipboard API，HTTP / 局域网 IP 等场景降级 execCommand */
export async function copyTextToClipboard(text: string): Promise<boolean> {
  const value = (text ?? "").trim();
  if (!value) {
    return false;
  }
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    /* 非安全上下文等场景降级 */
  }
  return legacyCopyToClipboard(value);
}
